module.exports = __webpack_public_path__ + "img/logo_340x340.82164588.png";